import React from 'react';
import cn from 'classnames';

export const Notice = ({ children, type = 'default', className = '' }) => {
    return <div className={cn('dm-notice', type, className)}>{children}</div>;
};
